import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { FoodAnalysisProvider } from './contexts/FoodAnalysisContext';
import AILayout from './components/Layout/AILayout';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import EnhancedDashboard from './pages/EnhancedDashboard';
import FoodScanner from './pages/FoodScanner';
import RecipeGenerator from './pages/RecipeGenerator';
import NutritionAnalysis from './pages/NutritionAnalysis';
import ARCookingAssistant from './pages/ARCookingAssistant';
import HealthIntegration from './pages/HealthIntegration';
import MealPlanner from './pages/MealPlanner';
import SmartKitchen from './pages/SmartKitchen';
import Recipes from './pages/Recipes';
import RecipeDetail from './pages/RecipeDetail';
import AIAssistant from './pages/AIAssistant';
import FoodRecognition from './pages/FoodRecognition';
import Subscription from './pages/Subscription';
import VideoTutorials from './pages/VideoTutorials';
import About from './pages/About';
import Contact from './pages/Contact';
import Advertisements from './pages/Advertisements';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import ParticleBackground from './components/UI/ParticleBackground';

function App() {
  return (
    <AuthProvider>
      <FoodAnalysisProvider>
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden">
            <ParticleBackground />
            <div className="relative z-10">
              <AILayout>
                <Navbar />
                <main className="pt-20">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/dashboard" element={
                      <ProtectedRoute>
                        <EnhancedDashboard />
                      </ProtectedRoute>
                    } />
                    <Route path="/dashboard-original" element={
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    } />
                    <Route path="/food-scanner" element={<FoodScanner />} />
                    <Route path="/recipe-generator" element={<RecipeGenerator />} />
                    <Route path="/nutrition-analysis" element={<NutritionAnalysis />} />
                    <Route path="/ar-cooking" element={<ARCookingAssistant />} />
                    <Route path="/health-integration" element={<HealthIntegration />} />
                    <Route path="/meal-planner" element={<MealPlanner />} />
                    <Route path="/smart-kitchen" element={<SmartKitchen />} />
                    <Route path="/recipes" element={<Recipes />} />
                    <Route path="/recipes/:id" element={<RecipeDetail />} />
                    <Route path="/ai-assistant" element={<AIAssistant />} />
                    <Route path="/food-recognition" element={<FoodRecognition />} />
                    <Route path="/subscription" element={<Subscription />} />
                    <Route path="/tutorials" element={<VideoTutorials />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/ads" element={<Advertisements />} />
                  </Routes>
                </main>
                <Footer />
              </AILayout>
            </div>
          </div>
        </Router>
      </FoodAnalysisProvider>
    </AuthProvider>
  );
}

export default App;